import http from './http'
import Loader from './loader'
import MicroModal from 'micromodal'
export default class Newsletter {
    constructor (el) {
        this.form = el
        this.loader = new Loader(this.form.querySelector('[type="submit"]'), 'Subscribing...', this.form)
        this.redirect = this.form.dataset.redirectUrl || null

        this.form.addEventListener('submit', (e) => {
            e.preventDefault()
            this.submitHandler()
        })
    }

    async submitHandler () {
        try {
            this.loader.start()
            const formData = new FormData(this.form)
            const response = await http.post('newsletter_signup', formData)
            if (response.data.success) {
                this.loader.stop('Subscribed!')
                const modal = this.form.closest('.modal')
                if (modal) {
                    setTimeout(() => {
                        MicroModal.close(modal.id)
                    }, 1000)
                }
                if (this.redirect) {
                    window.location.href = this.redirect
                }
            } else {
                this.loader.error(response.data.data)
            }
        } catch (error) {
            this.loader.error(error.message)
        }
    }
}